(function () {
    'use strict';
    var modes = {
        SCENE_VIEWER: 'scene-viewer',
        ARQUICKLOOK: 'arquicklook',
        QR: 'qr',
    };
    window.cylindo.addModule('cylindo.helpers.ar.modes', modes);
}).call(this);
